module.exports = __webpack_public_path__ + "img/e_voucher_point.fd27faa5.png";